module.exports = __webpack_public_path__ + "img/65.0436719c.png";